/* Satinstones: header drawer, product page, cart, quick add, reveal (no theme dependencies) */
(function(){
  'use strict';
  var d = document, root = d.documentElement;
  root.classList.add('sc-js');
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  function $(s, c){ return (c || d).querySelector(s); }
  function $$(s, c){ return Array.prototype.slice.call((c || d).querySelectorAll(s)); }

  function initReveal(){
    var els = $$('.sc-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function(el){ el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function(el){ io.observe(el); });
    setTimeout(function(){ $$('.sc-reveal:not(.is-in)').forEach(function(el){ el.classList.add('is-in'); }); }, 2500);
  }

  function initHeader(){
    var drawer = $('#ScDrawer');
    var opener = $('[data-sc-drawer-open]');
    if (drawer && opener && !opener.dataset.scBound){
      opener.dataset.scBound = '1';
      var open = function(){
        drawer.hidden = false; root.classList.add('sc-lock');
        requestAnimationFrame(function(){ drawer.classList.add('is-open'); });
        opener.setAttribute('aria-expanded','true');
        var f = drawer.querySelector('a,button,summary'); if (f) f.focus();
      };
      var close = function(){
        drawer.classList.remove('is-open'); root.classList.remove('sc-lock');
        opener.setAttribute('aria-expanded','false');
        setTimeout(function(){ drawer.hidden = true; }, 320);
        opener.focus();
      };
      opener.addEventListener('click', open);
      $$('[data-sc-drawer-close]', drawer).forEach(function(b){ b.addEventListener('click', close); });
      d.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !drawer.hidden) close(); });
      window.addEventListener('resize', function(){ if (window.innerWidth >= 990 && !drawer.hidden) close(); });
    }
    var header = $('.sc-header');
    if (header){
      var onScroll = function(){ header.classList.toggle('is-scrolled', window.scrollY > 10); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    var search = $('.sc-search');
    if (search && !search.dataset.scBound){
      search.dataset.scBound = '1';
      search.addEventListener('toggle', function(){ if (search.open){ var i = $('input[type=search]', search); if (i) setTimeout(function(){ i.focus(); }, 30); } });
      d.addEventListener('click', function(e){ if (search.open && !search.contains(e.target)) search.removeAttribute('open'); });
    }
  }

  function formatMoney(cents, format){
    format = format || '${{amount}}';
    cents = Number(cents) || 0;
    function fmt(n, dec, ts, ds){
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(ds);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function(m, key){
      switch (key){
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  var toastEl, toastTimer;
  function toast(msg){
    if (!toastEl){
      toastEl = d.createElement('div'); toastEl.className = 'sc-toast';
      toastEl.setAttribute('role','status'); toastEl.setAttribute('aria-live','polite');
      d.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var span = d.createElement('span'); span.textContent = msg;
    var a = d.createElement('a'); a.href = base + 'cart'; a.textContent = 'View cart';
    toastEl.appendChild(span); toastEl.appendChild(a);
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function(){ toastEl.classList.remove('is-on'); }, 4500);
  }
  function setCount(n){
    $$('.js-cart-count').forEach(function(el){ el.textContent = n; if (n > 0) el.removeAttribute('data-empty'); else el.setAttribute('data-empty',''); });
  }

  d.addEventListener('submit', function(e){
    var form = e.target.closest && e.target.closest('form[data-sc-quick]');
    if (!form) return;
    var submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') return;
    e.preventDefault();
    var btns = $$('[type="submit"], [data-sc-sticky-add]', form.closest('[data-sc-product]') || form);
    var err = $('.sc-quick__err', form);
    btns.forEach(function(b){ b.disabled = true; b.setAttribute('aria-busy','true'); });
    if (err){ err.hidden = true; err.textContent = ''; }
    fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || j.message || 'Sorry, this item could not be added.'); return j; }); })
      .then(function(item){
        return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
          setCount(cart.item_count);
          var det = form.closest('details'); if (det) det.removeAttribute('open');
          toast((item.product_title || 'Item') + ' added to your cart');
          d.dispatchEvent(new CustomEvent('sc:cart-updated', { detail: cart }));
        });
      })
      .catch(function(ex){ if (err){ err.textContent = ex.message; err.hidden = false; } else { alert(ex.message); } })
      .then(function(){
        btns.forEach(function(b){ b.removeAttribute('aria-busy'); if (!b.hasAttribute('data-sc-soldout')) b.disabled = false; });
      });
  });

  d.addEventListener('click', function(e){
    var step = e.target.closest && e.target.closest('[data-sc-step]');
    if (!step) return;
    var wrap = step.closest('.sc-qty'); var input = wrap && $('input', wrap);
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var v = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-sc-step'), 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function initCart(){
    var form = $('[data-sc-cart]'); if (!form) return;
    var t;
    form.addEventListener('change', function(e){
      if (!e.target.matches('[data-sc-cart-qty]')) return;
      clearTimeout(t);
      t = setTimeout(function(){
        var u = $('[data-sc-update]', form);
        if (form.requestSubmit && u) form.requestSubmit(u); else { var h = d.createElement('input'); h.type='hidden'; h.name='update'; h.value='1'; form.appendChild(h); form.submit(); }
      }, 500);
    });
  }

  function initProduct(sec){
    if (sec.dataset.scBound) return; sec.dataset.scBound = '1';
    var dataEl = $('[data-sc-variants]', sec);
    var variants = []; try { variants = JSON.parse(dataEl.textContent); } catch(x){}
    var fmt = sec.getAttribute('data-money-format');
    var form = $('form[data-sc-product-form]', sec);
    var idInput = form && $('[data-sc-variant-id]', form);
    var fieldsets = $$('[data-sc-option]', sec);
    var addBtn = $('[data-sc-add]', sec);
    var stickyBtn = $('[data-sc-sticky-add]', sec);
    var priceEl = $('[data-sc-price]', sec), compareEl = $('[data-sc-compare]', sec), badge = $('[data-sc-sale-badge]', sec);
    var stickyPrice = $('[data-sc-sticky-price]', sec), stockEl = $('[data-sc-stock]', sec);

    var track = $('[data-sc-gal-track]', sec), thumbs = $$('[data-sc-thumb]', sec), slides = track ? $$('.sc-gal__slide', track) : [];
    var curEl = $('[data-sc-gal-current]', sec);
    function goTo(i, smooth){
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function activeIndex(){ return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
    if (track){
      var start = parseInt(sec.getAttribute('data-start') || '0', 10);
      if (start) requestAnimationFrame(function(){ goTo(start, false); });
      var st;
      track.addEventListener('scroll', function(){
        clearTimeout(st); st = setTimeout(function(){
          var i = activeIndex();
          thumbs.forEach(function(t, k){ t.classList.toggle('is-active', k === i); });
          if (curEl) curEl.textContent = i + 1;
        }, 80);
      }, { passive: true });
      thumbs.forEach(function(t){ t.addEventListener('click', function(){ goTo(parseInt(t.getAttribute('data-sc-thumb'), 10)); }); });
      var prev = $('[data-sc-gal-prev]', sec), next = $('[data-sc-gal-next]', sec);
      if (prev) prev.addEventListener('click', function(){ var i = activeIndex(); goTo(i > 0 ? i - 1 : slides.length - 1); });
      if (next) next.addEventListener('click', function(){ var i = activeIndex(); goTo(i < slides.length - 1 ? i + 1 : 0); });
    }
    var dlg = $('[data-sc-zoom-dialog]', sec), zimg = $('[data-sc-zoom-img]', sec);
    $$('[data-sc-zoom]', sec).forEach(function(b){
      b.addEventListener('click', function(){
        if (!dlg || !dlg.showModal) { window.open(b.getAttribute('data-sc-zoom'), '_blank'); return; }
        zimg.src = b.getAttribute('data-sc-zoom'); dlg.showModal();
      });
    });
    if (dlg){
      var zc = $('[data-sc-zoom-close]', dlg); if (zc) zc.addEventListener('click', function(){ dlg.close(); });
      dlg.addEventListener('click', function(e){ if (e.target === dlg) dlg.close(); });
    }

    function selected(){ return fieldsets.map(function(fs){ var c = $('input:checked', fs); return c ? c.value : null; }); }
    function findVariant(opts){
      for (var i = 0; i < variants.length; i++){
        var v = variants[i], ok = true;
        for (var k = 0; k < opts.length; k++){ if (v.options[k] !== opts[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts){
      fieldsets.forEach(function(fs, idx){
        $$('input', fs).forEach(function(inp){
          var test = opts.slice(); test[idx] = inp.value;
          var v = findVariant(test);
          inp.closest('.sc-opt__pill').classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function setBtn(btn, label, disabled){
      if (!btn) return;
      btn.textContent = label; btn.disabled = disabled;
      if (disabled) btn.setAttribute('data-sc-soldout',''); else btn.removeAttribute('data-sc-soldout');
    }
    function update(){
      var opts = selected();
      fieldsets.forEach(function(fs, i){ var s = $('[data-sc-opt-value]', fs); if (s) s.textContent = opts[i] || ''; });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v){
        setBtn(addBtn, 'Unavailable', true); setBtn(stickyBtn, 'Unavailable', true);
        if (stockEl) stockEl.innerHTML = '<span class="is-out">This combination is unavailable</span>';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price, fmt);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price, fmt);
      var sale = v.compare && v.compare > v.price;
      if (compareEl){ compareEl.hidden = !sale; compareEl.textContent = sale ? formatMoney(v.compare, fmt) : ''; }
      if (badge) badge.hidden = !sale;
      setBtn(addBtn, v.available ? 'Add to Cart' : 'Sold Out', !v.available);
      setBtn(stickyBtn, v.available ? 'Add to Cart' : 'Sold Out', !v.available);
      if (stockEl) stockEl.innerHTML = v.available ? '<span class="is-in">In stock</span>' : '<span class="is-out">Sold out</span>';
      if (v.media && track){
        for (var i = 0; i < slides.length; i++){ if (String(slides[i].getAttribute('data-media-id')) === String(v.media)) { goTo(i); break; } }
      }
      if (window.history && history.replaceState){
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    fieldsets.forEach(function(fs){ fs.addEventListener('change', update); });
    if (fieldsets.length) markAvailability(selected());

    var sticky = $('[data-sc-sticky]', sec), buy = $('[data-sc-buy]', sec);
    if (sticky && buy && 'IntersectionObserver' in window){
      sticky.hidden = false;
      var io = new IntersectionObserver(function(en){
        var e = en[0]; var below = e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', !e.isIntersecting && below);
      });
      io.observe(buy);
    }
    if (stickyBtn && form){
      stickyBtn.addEventListener('click', function(){
        if (form.requestSubmit) form.requestSubmit(addBtn || undefined);
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  function init(){
    initReveal(); initHeader(); initCart();
    $$('[data-sc-product]').forEach(initProduct);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', function(){ initReveal(); initHeader(); $$('[data-sc-product]').forEach(initProduct); });
})();
